define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getCatchError = void 0;
    var getCatchError = function (error, errorMessage) {
        if (error instanceof Error) {
            return error;
        }
        if (typeof error === "string" || typeof error === "number") {
            return Error(error.toString());
        }
        return Error(errorMessage || "An error was unable to be parsed correctly");
    };
    exports.getCatchError = getCatchError;
});
//# sourceMappingURL=index.js.map